import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../../client";
import BlockContent from "@sanity/block-content-to-react";
import { Link } from "react-router-dom";
import NavAr from "./NavAr";
import FooterAr from "./FooterAr";
import Loading from "../components/Loading";


function SinglePropertyAr({ lang }) {
  console.log("Start ---------");

  const [loading, setLoading] = useState(true);
  const [img, setImg] = useState(null);
  const arabic = { direction: "rtl" };
  const { slug } = useParams();

  const [project, setProject] = useState(null);
  const [antherProjects, setAntherProjects] = useState(null);
  


  
useEffect(() => {
  document.querySelector("html").lang = "ar";

}, [])
  useEffect(() => {
    // get project Data
    sanityClient
      .fetch(
        `
      *[_type=="properties" && Slug.current=="${slug}"]{
        "description": description.ar,
        "images": images[].asset->url,
        "projectType": projectType.ar,
        "address": address.ar,
        "type" : type.ar,
        "name": name.ar,
      }
    `
      )
      .then((data) => {
        setProject(data[0]);
        document.title = `${data[0].name} - CompanyName`;
        setLoading(false);
      });

      

    console.log("get another data");
    // Get Another Data
    sanityClient
      .fetch(
        `*[_type=="properties"] | order(_createdAt desc) {
          "name": name.ar,
          "slug": Slug.current,
          "imgUrl" : images[0].asset->url
        }[0...3]`
      )
      .then((data) => {
        setAntherProjects(data);
        setLoading(false);
      })
      .catch((err) => console.log(err));

    console.log("finsih Effect");
  }, [slug]);

  console.log("render");

  console.log(`Loading - ${loading}`);
  if (loading) {
    return <Loading />;
  }

  

  const style = {
    textAlign: "right",
  };
  return (
    <>
     <NavAr url={`/properties/${slug}`}/>
    <div className="single" style={arabic}>
      {project && (
        <>
          <div className="left">
            <div className="c-img">
              <img src={img || project.images[0]} alt="GT-Home Img" />
            </div>
            <div className="images">
              {project.images.map((image, index) => {
                return (
                  <img
                    src={image}
                    alt="GT-Home Img"
                    onClick={() => setImg(image)}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
          <div className="right">
            <h2 className="h2" style={style}>{project.name}</h2>
            <div className="description" style={style}>
              <BlockContent blocks={project.description} />
            </div>
          </div>
          <div className="projects">
            <div className="all">
              {antherProjects &&
                antherProjects.map(({ name, slug, imgUrl }) => {
                  return (
                    <Project
                      img={imgUrl}
                      projectName={name}
                      key={slug}
                      slug={slug}
                    />
                  );
                })}
            </div>
          </div>
        </>
      )}
    </div>
    <FooterAr />
    </>
  );
}

function Project({ img, projectName, slug }) {
  return (
    <div className="project">
      <Link to={"/ar/properties/" + slug}>
        <img src={img} alt={projectName} />

        <h3>{projectName}</h3>
      </Link>
    </div>
  );
}

export default SinglePropertyAr;
